import { render, staticRenderFns } from "./AdminCommands.vue?vue&type=template&id=26d7d13a&scoped=true"
import script from "./AdminCommands.vue?vue&type=script&lang=js"
export * from "./AdminCommands.vue?vue&type=script&lang=js"
import style0 from "./AdminCommands.vue?vue&type=style&index=0&id=26d7d13a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d7d13a",
  null
  
)

export default component.exports